import Dialog from '@zenbusiness/zui/Dialog';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import IconButton from '@zenbusiness/zui/IconButton';
import { styled } from '@zenbusiness/zui/styles';

const DialogStyle = () => ({
  padding: 0
});

const DialogTitleStyle = ({ theme, titlesize }) => ({
  position: 'relative',
  padding: 0,
  height: titlesize === 'small' ? '50px' : '104px',
  [theme.breakpoints.up('sm')]: {
    height: titlesize === 'small' ? '68px' : '144px'
  }
});
const CloseButtonStyle = ({ titlesize }) =>
  titlesize === 'small'
    ? {
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translate(-50%, -50%)'
      }
    : {
        position: 'absolute',
        right: '5px',
        top: '10px'
      };

export const CloseButtonStyled = styled(IconButton)(CloseButtonStyle);
export const DialogStyled = styled(Dialog)(DialogStyle);
export const DialogTitleStyled = styled(DialogTitle)(DialogTitleStyle);
